import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

import StaffNeededTrainingsModal from './StaffNeededTrainingsModal';
import StaffNeededTrainingsOldModal from './StaffNeededTrainingsOldModal';
import getLocale from '../../../i18n/getLocale';



class StaffNeededTrainingsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      date: null,
      motivo: null,
      other_reason: null,
      conhecimento_analise: null,
      outras_atividades: null,
      print_integracao: null,
      print_geral: null,
      print_sup: null,
      print_fer: null,
      print_mnt: null,
      print_eng: null,
      print_ctm: null,
      print_sasc: null,
      print_qua: null,
      print_inspetores: null,
      print_rampa: null,
      apoio_corrosao: null,
      apoio_pbn: null,
      apoio_hums1: null,
      apoio_hums2: null,
      apoio_ingles: null,
      apoio_boroscopia: null,
      apoio_fatores_humanos: null,
      apoio_orientacao_pedagogica: null,
      apoio_artigos_perigosos: null,
      apoio_eos: null,
      staff_id: this.props.staff_id,
      show_other: false,
      staff_needed_trainings: [],
      staff_necessities: [],
      modal_new: false,
      modal_old: false,
      data_modal_new: {},
      data_modal_old: {},
      staff_needed_trainings_new: [],
      staff_needed_trainings_old: [],
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.addNew = this.addNew.bind(this);
    // this.addOld = this.addOld.bind(this);
    // this.delete = this.delete.bind(this);
    // this.deleteNew = this.deleteNew.bind(this);
    // this.deleteOld = this.deleteOld.bind(this);
    this.editModalNew = this.editModalNew.bind(this);
    this.closeModalNew = this.closeModalNew.bind(this);
    this.closeModalOld = this.closeModalOld.bind(this);
    this.editModalOld = this.editModalOld.bind(this);
    this.exportNecessity = this.exportNecessity.bind(this);
    this.exportNeeded = this.exportNeeded.bind(this);
    this.exportNeededNew = this.exportNeededNew.bind(this);

    this.locale = getLocale();
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
    if (event.value === 'Outro') {
      this.setState({show_other: true});
    } else {
      this.setState({show_other: false});
    }
  }

  handleCheckboxChange (name, event) {
    var change = {};
    if(event.target.checked == true) {
      change[event.target.name] = true;
    } else {
      change[event.target.name] = false;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.staff_needed_trainings) && Array.isArray(newProps.staff_needed_trainings_new)) {
      this.setState({
        staff_needed_trainings: newProps.staff_needed_trainings,
        staff_needed_trainings_new: newProps.staff_needed_trainings_new,
        staff_necessities: newProps.staff_necessities,
        loaded: 1
      });
    }
  }
  
  // Fetch salvando a edição
  // addNew(event) {
  //   event.preventDefault();
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.state.staff_id,
  //     date: this.state.date,
  //     outras_atividades: this.state.outras_atividades,
  //     motivo: this.state.motivo,
  //     other_reason: this.state.other_reason,
  //     print_integracao: this.state.print_integracao,
  //     print_geral: this.state.print_geral,
  //     print_sup: this.state.print_sup,
  //     print_fer: this.state.print_fer,
  //     print_mnt: this.state.print_mnt,
  //     print_eng: this.state.print_eng,
  //     print_ctm: this.state.print_ctm,
  //     print_sasc: this.state.print_sasc,
  //     print_qua: this.state.print_qua,
  //     print_inspetores: this.state.print_inspetores,
  //     print_rampa: this.state.print_rampa,
  //     apoio_corrosao: this.state.apoio_corrosao,
  //     apoio_pbn: this.state.apoio_pbn,
  //     apoio_hums1: this.state.apoio_hums1,
  //     apoio_hums2: this.state.apoio_hums2,
  //     apoio_ingles: this.state.apoio_ingles,
  //     apoio_boroscopia: this.state.apoio_boroscopia,
  //     apoio_fatores_humanos: this.state.apoio_fatores_humanos,
  //     apoio_orientacao_pedagogica: this.state.apoio_orientacao_pedagogica,
  //     apoio_artigos_perigosos: this.state.apoio_artigos_perigosos,
  //     apoio_eos: this.state.apoio_eos,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento/novo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       self.setState({ staff_needed_trainings_new: responseJson.data });
  //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }
  
  // // Fetch salvando a edição
  // add(event) {
  //   event.preventDefault();
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.state.staff_id,
  //     date: this.state.date,
  //     conhecimento_analise: this.state.conhecimento_analise,
  //     outras_atividades: this.state.outras_atividades,
  //     print_integracao: this.state.print_integracao,
  //     print_geral: this.state.print_geral,
  //     print_sup: this.state.print_sup,
  //     print_fer: this.state.print_fer,
  //     print_mnt: this.state.print_mnt,
  //     print_eng: this.state.print_eng,
  //     print_ctm: this.state.print_ctm,
  //     print_sasc: this.state.print_sasc,
  //     print_qua: this.state.print_qua,
  //     print_inspetores: this.state.print_inspetores,
  //     print_rampa: this.state.print_rampa,
  //     apoio_corrosao: this.state.apoio_corrosao,
  //     apoio_pbn: this.state.apoio_pbn,
  //     apoio_hums1: this.state.apoio_hums1,
  //     apoio_hums2: this.state.apoio_hums2,
  //     apoio_ingles: this.state.apoio_ingles,
  //     apoio_boroscopia: this.state.apoio_boroscopia,
  //     apoio_fatores_humanos: this.state.apoio_fatores_humanos,
  //     apoio_orientacao_pedagogica: this.state.apoio_orientacao_pedagogica,
  //     apoio_artigos_perigosos: this.state.apoio_artigos_perigosos,
  //     apoio_eos: this.state.apoio_eos,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       self.setState({ staff_needed_trainings: responseJson.data });
  //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }
  
  // // Fetch salvando a edição
  // addOld(event) {
  //   event.preventDefault();
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.state.staff_id,
  //     conhecimento: this.state.conhecimento,
  //     experiencia: this.state.experiencia,
  //     oficina: this.state.oficina,
  //     aeronaves: this.state.aeronaves,
  //     motores: this.state.motores,
  //     inspecao: this.state.inspecao,
  //     instrucao: this.state.instrucao,
  //     atividades: this.state.atividades,
  //     date: this.state.date,
  //     only_active: this.state.only_active,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento/antigo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       self.setState({ staff_necessities: responseJson.data });
  //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }
    
  // // Fetch deletando um item
  // delete (event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de delete essa frota?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_needed_trainings: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }

  // // Fetch deletando um item
  // deleteNew (event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de delete essa frota?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento/novo/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_needed_trainings: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }

  // // Fetch deletando um item
  // deleteOld (event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de delete essa frota?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/frota_obrigatoria/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_needed_trainings: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }

    editModalNew (staff_needed_training, staff_needed_trainings) {
      this.setState({ modal_new: true, data_modal_new: staff_needed_training, staff_needed_trainings: staff_needed_trainings });
    }

   closeModalNew (staff_needed_trainings) {
      this.setState({ modal_new: false, staff_needed_trainings_new: staff_needed_trainings});
    }

  editModalOld (staff_needed_training, staff_needed_trainings) {
    this.setState({ modal_old: true, data_modal_old: staff_needed_training, staff_needed_trainings: staff_needed_trainings });
  }

 closeModalOld (staff_needed_trainings) {
    this.setState({ modal_old: false, staff_needed_trainings: staff_needed_trainings});
  }
  exportNecessity(event) {
    var self = this;
    var staff_necessity = event;
    var url = '/exportar/necessidade/treinamento/antigo/colaborador/';
    var header = this.refs.request_api.header('application/json');
    self.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + url + staff_necessity, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
        self.props.handleAlert('', '', 'closed');
      });
    });
  }
  exportNeeded(event) {
    var self = this;
    var staff_needed_training_id = event;
    var url = '/exportar/necessidade/treinamento/colaborador/';
    var header = this.refs.request_api.header('application/json');
    self.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + url + staff_needed_training_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
        self.props.handleAlert('', '', 'closed');
      });
    });
  }
  exportNeededNew(event) {
    var self = this;
    var staff_needed_training_id = event;
    var url = '/exportar/necessidade/treinamento/colaborador/novo/';
    var header = this.refs.request_api.header('application/json');
    self.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + url + staff_needed_training_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
        self.props.handleAlert('', '', 'closed');
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <StaffNeededTrainingsModal modal_new={self.state.modal_new} staff_needed_trainings={self.state.staff_needed_trainings_new} data_modal_new={self.state.data_modal_new} closeModalNew={self.closeModalNew} handleAlert={self.props.handleAlert} />
  <StaffNeededTrainingsOldModal modal_old={self.state.modal_old} staff_needed_trainings={self.state.staff_needed_trainings} data_modal_old={self.state.data_modal_old} closeModalOld={self.closeModalOld} handleAlert={self.props.handleAlert} />
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tituloAvaliacaoDeNecessidadeDeTreinamento}</h3>
  <hr/>
  {(this.state.staff_needed_trainings_new === null || typeof this.state.staff_needed_trainings_new === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.naoHaFormulariosDeAvaliacao}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabela.Data}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabela.MotivoDaAnalise}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabela.OutrasAtividades}</th>
          <th className="col-md-2 text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabela.Acoes}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_needed_trainings_new).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_needed_trainings_new[k].date_str}</td>
              <td className="text-center">{self.state.staff_needed_trainings_new[k].motivo}</td>
              <td className="text-center">{self.state.staff_needed_trainings_new[k].outras_atividades}</td>
              <td className="text-center">
                <button className="btn btn-info btn-sm" onClick={() => {self.exportNeededNew(self.state.staff_needed_trainings_new[k].id)}}><i className="fa fa-fw fa-file-pdf-o"></i></button>
                <button className="btn btn-sm btn-primary" onClick={() => { self.editModalNew(self.state.staff_needed_trainings_new[k],self.state.staff_needed_trainings_new); }}><i className="fa fa-fw fa-pencil"></i></button>
                {/* <button className="btn btn-sm btn-danger" value={self.state.staff_needed_trainings_new[k].id} onClick={self.deleteNew}><i className="fa fa-fw fa-trash"></i></button> */}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
  }
  <hr/>
  {/* <form onSubmit={this.addNew}>
    <div className="row form-group">
      <div className="col-md-6 form-group">
        <label>Motivo da análise:</label>
        <Select
          className="form-field-name"
          name="motivo"
          value={this.state.motivo}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'motivo')}
          options={[
            {value: 'Contratação do Colaborador', label: 'Contratação do Colaborador'},
            {value: 'Nova Função do Colaborador', label: 'Nova Função do Colaborador'},
            {value: 'Promoção do Colaborador', label: 'Promoção do Colaborador'},
            {value: 'Outro', label: 'Outro'},
          ]}
        />
        {
          (self.state.show_other) ? 
          <div className="form-group">
            <br/>
            <label>Preencha o motivo:</label>
            <InputMask value={this.state.other_reason} name="other_reason" className="form-control" onChange={this.handleChange.bind(this, 'other_reason')} placeholder="" />
          </div>
          :
          ''
        }    
      </div>
      <div className="col-md-6 form-group">
        <label>Data:</label>
        <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" />
      </div>
    </div>
    <div className="form-group">
      <label>Outras atividades:</label>
      <textarea name="outras_atividades" className="form-control" value={this.state.outras_atividades} onChange={this.handleChange.bind(this, 'outras_atividades')} style={{ height: 200 }} />
    </div>
    <hr/>
    <h4>Procedimentos internos</h4>
    <hr/>
    <div className="row form-group">
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_integracao"
            type="checkbox"
            checked={self.state.print_integracao}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_integracao)} />
          &nbsp;&nbsp;Integração
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_geral"
            type="checkbox"
            checked={self.state.print_geral}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_geral)} />
          &nbsp;&nbsp;Geral
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_sup"
            type="checkbox"
            checked={self.state.print_sup}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_sup)} />
          &nbsp;&nbsp;SUP
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_fer"
            type="checkbox"
            checked={self.state.print_fer}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_fer)} />
          &nbsp;&nbsp;FER
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_mnt"
            type="checkbox"
            checked={self.state.print_mnt}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_mnt)} />
          &nbsp;&nbsp;MNT
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_eng"
            type="checkbox"
            checked={self.state.print_eng}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_eng)} />
          &nbsp;&nbsp;ENG
        </label>
      </div>
    </div>
    <div className="row form-group">
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_ctm"
            type="checkbox"
            checked={self.state.print_ctm}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_ctm)} />
          &nbsp;&nbsp;CTM
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_sasc"
            type="checkbox"
            checked={self.state.print_sasc}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_sasc)} />
          &nbsp;&nbsp;SASC
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_qua"
            type="checkbox"
            checked={self.state.print_qua}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_qua)} />
          &nbsp;&nbsp;QUA
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_inspetores"
            type="checkbox"
            checked={self.state.print_inspetores}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_inspetores)} />
          &nbsp;&nbsp;Inspetores
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_rampa"
            type="checkbox"
            checked={self.state.print_rampa}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_rampa)} />
          &nbsp;&nbsp;Rampa
        </label>
      </div>
    </div>
    <hr/>
    <h4>Apoio</h4>
    <hr/>
    <div className="row form-group">
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_corrosao"
            type="checkbox"
            checked={self.state.apoio_corrosao}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_corrosao)} />
          &nbsp;&nbsp;Corrosão
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_pbn"
            type="checkbox"
            checked={self.state.apoio_pbn}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_pbn)} />
          &nbsp;&nbsp;PBN
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_hums1"
            type="checkbox"
            checked={self.state.apoio_hums1}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_hums1)} />
          &nbsp;&nbsp;HUMS Nível 1
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_hums2"
            type="checkbox"
            checked={self.state.apoio_hums2}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_hums2)} />
          &nbsp;&nbsp;HUMS Nível 2
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_ingles"
            type="checkbox"
            checked={self.state.apoio_ingles}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_ingles)} />
          &nbsp;&nbsp;Inglês
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_boroscopia"
            type="checkbox"
            checked={self.state.apoio_boroscopia}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_boroscopia)} />
          &nbsp;&nbsp;Boroscopia
        </label>
      </div>
    </div>
    <div className="row form-group">
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_fatores_humanos"
            type="checkbox"
            checked={self.state.apoio_fatores_humanos}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_fatores_humanos)} />
          &nbsp;&nbsp;Fatores Humanos
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_orientacao_pedagogica"
            type="checkbox"
            checked={self.state.apoio_orientacao_pedagogica}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_orientacao_pedagogica)} />
          &nbsp;&nbsp;Orientação<br/>Pedagógica
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_artigos_perigosos"
            type="checkbox"
            checked={self.state.apoio_artigos_perigosos}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_artigos_perigosos)} />
          &nbsp;&nbsp;Artigos Perigosos
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_eos"
            type="checkbox"
            checked={self.state.apoio_eos}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_eos)} />
          &nbsp;&nbsp;EOS
        </label>
      </div>
    </div>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Gerar formulário</button>
  </form>
  <hr/> */}
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tituloAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo}</h3>
  <hr/>
  {(this.state.staff_needed_trainings === null || typeof this.state.staff_needed_trainings === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.naoHaFormulariosDeAvaliacao}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Conhecimento}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.OutrasAtividades}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Data}</th>
          <th className="col-md-2 text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Acoes}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_needed_trainings).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_needed_trainings[k].conhecimento_analise}</td>
              <td className="text-center">{self.state.staff_needed_trainings[k].outras_atividades}</td>
              <td className="text-center">{self.state.staff_needed_trainings[k].date_str}</td>
              <td className="text-center">
                <button className="btn btn-info btn-sm" onClick={() => {self.exportNeeded(self.state.staff_needed_trainings[k].id)}}><i className="fa fa-fw fa-file-pdf-o"></i></button>
                <button className="btn btn-sm btn-primary" onClick={() => { self.editModalOld(self.state.staff_needed_trainings[k], self.state.staff_needed_trainings); }}><i className="fa fa-fw fa-pencil"></i></button>
                {/* <button className="btn btn-sm btn-danger" value={self.state.staff_needed_trainings[k].id} onClick={self.delete}><i className="fa fa-fw fa-trash"></i></button> */}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  {/* <hr/>
  <form onSubmit={this.add}>
    <div className="row form-group">
      <div className="col-md-12 form-group">
        <label>Data:</label>
        <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" />
      </div>
    </div>
    <div className="row form-group">
      <div className="col-md-6 form-group">
        <label>Conhecimento e treinamento:</label>
        <textarea name="conhecimento_analise" className="form-control" value={this.state.conhecimento_analise} onChange={this.handleChange.bind(this, 'conhecimento_analise')} style={{ height: 200 }} />
      </div>
      <div className="col-md-6 form-group">
        <label>Outras atividades:</label>
        <textarea name="outras_atividades" className="form-control" value={this.state.outras_atividades} onChange={this.handleChange.bind(this, 'outras_atividades')} style={{ height: 200 }} />
      </div>
    </div>
    <hr/>
    <h4>Procedimentos internos</h4>
    <hr/>
    <div className="row form-group">
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_integracao"
            type="checkbox"
            checked={self.state.print_integracao}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_integracao)} />
          &nbsp;&nbsp;Integração
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_geral"
            type="checkbox"
            checked={self.state.print_geral}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_geral)} />
          &nbsp;&nbsp;Geral
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_sup"
            type="checkbox"
            checked={self.state.print_sup}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_sup)} />
          &nbsp;&nbsp;SUP
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_fer"
            type="checkbox"
            checked={self.state.print_fer}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_fer)} />
          &nbsp;&nbsp;FER
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_mnt"
            type="checkbox"
            checked={self.state.print_mnt}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_mnt)} />
          &nbsp;&nbsp;MNT
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_eng"
            type="checkbox"
            checked={self.state.print_eng}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_eng)} />
          &nbsp;&nbsp;ENG
        </label>
      </div>
    </div>
    <div className="row form-group">
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_ctm"
            type="checkbox"
            checked={self.state.print_ctm}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_ctm)} />
          &nbsp;&nbsp;CTM
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_sasc"
            type="checkbox"
            checked={self.state.print_sasc}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_sasc)} />
          &nbsp;&nbsp;SASC
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_qua"
            type="checkbox"
            checked={self.state.print_qua}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_qua)} />
          &nbsp;&nbsp;QUA
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_inspetores"
            type="checkbox"
            checked={self.state.print_inspetores}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_inspetores)} />
          &nbsp;&nbsp;Inspetores
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_rampa"
            type="checkbox"
            checked={self.state.print_rampa}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_rampa)} />
          &nbsp;&nbsp;Rampa
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="print_eng"
            type="checkbox"
            checked={self.state.print_eng}
            onChange={self.handleCheckboxChange.bind(self, self.state.print_eng)} />
          &nbsp;&nbsp;ENG
        </label>
      </div>
    </div>
    <hr/>
    <h4>Apoio</h4>
    <hr/>
    <div className="row form-group">
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_corrosao"
            type="checkbox"
            checked={self.state.apoio_corrosao}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_corrosao)} />
          &nbsp;&nbsp;Corrosão
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_pbn"
            type="checkbox"
            checked={self.state.apoio_pbn}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_pbn)} />
          &nbsp;&nbsp;PBN
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_hums1"
            type="checkbox"
            checked={self.state.apoio_hums1}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_hums1)} />
          &nbsp;&nbsp;HUMS Nível 1
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_hums2"
            type="checkbox"
            checked={self.state.apoio_hums2}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_hums2)} />
          &nbsp;&nbsp;HUMS Nível 2
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_ingles"
            type="checkbox"
            checked={self.state.apoio_ingles}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_ingles)} />
          &nbsp;&nbsp;Inglês
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_boroscopia"
            type="checkbox"
            checked={self.state.apoio_boroscopia}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_boroscopia)} />
          &nbsp;&nbsp;Boroscopia
        </label>
      </div>
    </div>
    <div className="row form-group">
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_fatores_humanos"
            type="checkbox"
            checked={self.state.apoio_fatores_humanos}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_fatores_humanos)} />
          &nbsp;&nbsp;Fatores Humanos
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_orientacao_pedagogica"
            type="checkbox"
            checked={self.state.apoio_orientacao_pedagogica}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_orientacao_pedagogica)} />
          &nbsp;&nbsp;Orientação<br/>Pedagógica
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_artigos_perigosos"
            type="checkbox"
            checked={self.state.apoio_artigos_perigosos}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_artigos_perigosos)} />
          &nbsp;&nbsp;Artigos Perigosos
        </label>
      </div>
      <div className="col-md-2 form-group">
        <label>
          <input
            name="apoio_eos"
            type="checkbox"
            checked={self.state.apoio_eos}
            onChange={self.handleCheckboxChange.bind(self, self.state.apoio_eos)} />
          &nbsp;&nbsp;EOS
        </label>
      </div>
    </div>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Gerar formulário</button>
  </form> */}
  <hr/>
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tituloAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo}</h3>
  <hr/>
  {(this.state.staff_necessities === null || typeof this.state.staff_necessities === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.naoHaFormulariosDeAvaliacao}</em></small><hr/></div> 
  : 
    <div>
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.ConhecimentoETreinamento}</th>
            <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Experiencia}</th>
            <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Oficina}</th>
            <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Aeronaves}</th>
            <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Motores}</th>
            <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Inspecao}</th>
            <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Instrucao}</th>
            <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.OutrasAtividades}</th>
            <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Criacao}</th>
            <th className="col-md-2 text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Acoes}</th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.staff_necessities).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.staff_necessities[k].conhecimento}</td>
                <td className="text-center">{self.state.staff_necessities[k].experiencia}</td>
                <td className="text-center">{self.state.staff_necessities[k].oficina}</td>
                <td className="text-center">{self.state.staff_necessities[k].aeronaves}</td>
                <td className="text-center">{self.state.staff_necessities[k].motores}</td>
                <td className="text-center">{self.state.staff_necessities[k].inspecao}</td>
                <td className="text-center">{self.state.staff_necessities[k].instrucao}</td>
                <td className="text-center">{self.state.staff_necessities[k].atividades}</td>
                <td className="text-center">{self.state.staff_necessities[k].date_str}</td>
                <td className="text-center">
                  <button className="btn btn-info btn-sm" onClick={() => {self.exportNecessity(self.state.staff_necessities[k].id)}}><i className="fa fa-fw fa-file-pdf-o"></i></button>
                  {/* <button className="btn btn-sm btn-danger" value={self.state.staff_necessities[k].id} onClick={self.deleteOld}><i className="fa fa-fw fa-trash"></i></button> */}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <hr/>
    </div>
  }
  <hr/>
  {/* <form onSubmit={this.addOld}>
    <div className="row form-group">
      <div className="col-md-12 form-group">
        <label>Data:</label>
        <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" />
      </div>
    </div>
    <div className="row form-group">
      <div className="col-md-6 form-group">
        <label>Conhecimento e treinamento:</label>
        <textarea name="conhecimento" className="form-control" value={this.state.conhecimento} onChange={this.handleChange.bind(this, 'conhecimento')} style={{ height: 200 }} />
      </div>
      <div className="col-md-6 form-group">
        <label>Experiência:</label>
        <textarea name="experiencia" className="form-control" value={this.state.experiencia} onChange={this.handleChange.bind(this, 'experiencia')} style={{ height: 200 }} />
      </div>
    </div>
    <hr/>
    <h4>Execução de Serviço de Manutenção</h4>
    <hr/>
    <div className="row form-group">
      <div className="col-md-6 form-group">
        <label>Em oficina:</label>
        <textarea name="oficina" className="form-control" value={this.state.oficina} onChange={this.handleChange.bind(this, 'oficina')} style={{ height: 200 }} />
      </div>
      <div className="col-md-6 form-group">
        <label>Em aeronaves:</label>
        <textarea name="aeronaves" className="form-control" value={this.state.aeronaves} onChange={this.handleChange.bind(this, 'aeronaves')} style={{ height: 200 }} />
      </div>
    </div>
    <div className="row form-group">
      <div className="col-md-6 form-group">
        <label>Em motores:</label>
        <textarea name="motores" className="form-control" value={this.state.motores} onChange={this.handleChange.bind(this, 'motores')} style={{ height: 200 }} />
      </div>
    </div>
    <hr/>
    <div className="row form-group">
      <div className="col-md-6 form-group">
        <label>Inspeção de Serviços de Manutenção:</label>
        <textarea name="inspecao" className="form-control" value={this.state.inspecao} onChange={this.handleChange.bind(this, 'inspecao')} style={{ height: 200 }} />
      </div>
      <div className="col-md-6 form-group">
        <label>Instrução:</label>
        <textarea name="instrucao" className="form-control" value={this.state.instrucao} onChange={this.handleChange.bind(this, 'instrucao')} style={{ height: 200 }} />
      </div>
    </div>
    <div className="row form-group">
      <div className="col-md-6 form-group">
        <label>Outras atividades:</label>
        <textarea name="atividades" className="form-control" value={this.state.atividades} onChange={this.handleChange.bind(this, 'atividades')} style={{ height: 200 }} />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Gerar formulário</button>
  </form> */}
</div>
    );
  }
}

export default StaffNeededTrainingsTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffNeededTrainingsTab.js